import React from 'react';

export const OpeningHoursIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" {...props}>
        <path
            fill="currentColor"
            d="M13.16 6.12a1.06 1.06 0 00-1.03 1.03v5.95l-2.41 2.24a.98.98 0 00-.13 1.4c.2.2.48.33.77.33a.92.92 0 00.66-.27l2.75-2.52a.86.86 0 00.36-.7V7.14a1.04 1.04 0 00-.97-1.03z"
        />
        <path
            fill="currentColor"
            d="M12.5 0a12.5 12.5 0 100 25 12.5 12.5 0 000-25zm0 23.24a10.74 10.74 0 110-21.48 10.74 10.74 0 010 21.48z"
        />
    </svg>
);
